export function isIFrameSameOrigin(url: string | string[], origin: string) {
  let urlArray = [];
  if (typeof url === 'string') {
    urlArray.push(url);
  } else {
    urlArray = url;
  }

  return urlArray.some((url) => {
    const baseUrl = new URL(url);
    const originUrl = new URL(origin);

    if (originUrl.hostname !== baseUrl.hostname) {
      return false;
    }
    return true;
  });
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/is-same-origin.ts